import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'isEmpty',
  standalone: true
})
export class IsEmptyPipe implements PipeTransform {

  transform(data: unknown): boolean {
    // console.log('data:', data)
    return _.isEmpty(data);
  }

}
